import React from 'react';

import ContentfulImage from '../../Common/ContentfulImage';
import RichTextConverter from '../../Common/RichText/RichTextConverter';
import * as styles from './Sidebar.module.scss';

export default function Sidebar({ sidebar }) {
  return (
    <div className={styles.sidebar}>
      <h3>{sidebar.heading}</h3>
      {sidebar.sectionCopy && <RichTextConverter copy={sidebar.sectionCopy} />}
      {sidebar.content.map((item, i) => {
        return (
          <div className={[styles.contentCard, styles[item.accentColor?.toLowerCase()]].join(' ')} key={i}>
            {item.image && <ContentfulImage className={styles.image} imageFragment={item.image} lazy={true} />}
            <div className={styles.content}>
              <h4>{item.title}</h4>
              <RichTextConverter copy={item.body} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
